
<template>
  <Register />
</template>
  
  <script>
import Register from "../components/RegisterUser.vue";
export default {
  components: {
    Register,
  },
  setup() {
    return {};
  },
};
</script>
  <style module>
</style>
  